interface SnackbarMessageSlice {
    message: string | null; // Holds the message
    messageType: 'success' | 'error' | 'warning' | 'info'; // Type of message
    isMessageVisible: boolean; // Controls the visibility
    setMessage: (
        message: string,
        messageType: 'success' | 'error' | 'warning' | 'info',
        duration?: number
    ) => void; // Updates the  message
    clearMessage: () => void; // Clears the  message
    toggleMessageVisibility: () => void; // Toggles visibility
}

const createMessageSlice = (set: any): SnackbarMessageSlice => ({
    message: null,
    messageType: 'success',
    isMessageVisible: false,
    // Set message and show it for a specified duration
    setMessage: (
        message: string,
        messageType: string,
        duration: number = 5000
    ) => {
        set(() => ({
            message: message,
            isMessageVisible: true,
            messageType: messageType,
        })); // Set and show message
        setTimeout(() => {
            set(() => ({ message: null, isMessageVisible: false })); // Clear after duration
        }, duration); // Default duration is 3 seconds
    },

    // Clear the message immediately
    clearMessage: () => set(() => ({ message: null, isMessageVisible: false })),

    // Toggle the visibility of the message
    toggleMessageVisibility: () =>
        set((state: SnackbarMessageSlice) => ({
            isMessageVisible: !state.isMessageVisible,
        })),
});

export { createMessageSlice };
export type { SnackbarMessageSlice };
